import {
  queryAddEditPreFilter,
  queryAddNewPreFilter,
  queryDeleteItem,
  queryEditActive,
  queryEditItemPreFilter,
  queryList,
} from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'processCustomListPreFilter',
  state: {
    newPreFilter: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select: 'id,preFilterType,filterValue',
    notSelectSearch: 'order,preFilterType',
    expand: {
      form: { select: 'name' },
      field: { select: 'displayText' },
      variable: { select: 'internalName' },
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
    isActive: '',
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'queryPreFilters',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewPreFilter({ payload }, { put }) {
      yield put({
        type: 'addPreFilter',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewPreFilter',
          payload,
        });
      }
    },

    *editItemPreFilter({ payload }, { call, put }) {
      try {
        const table = yield call(queryEditItemPreFilter, payload);
        yield put({
          type: 'editPreFilter',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewPreFilter({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewPreFilter, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'savePreFilter',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditPreFilter({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddEditPreFilter, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'savePreFilter',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ payload }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, payload.id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'savePreFilter',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${payload.view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: payload.view,
            },
          });
        }
      }
    },

    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (error) {
        /* try */
      }
    },

    *search({ payload }, { put }) {
      yield put({
        type: payload.type,
        payload: payload.str,
      });
    },

    *showItemPreFilter({ view }, { put }) {
      yield put({
        type: 'showEditItemPreFilter',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
    *statePreFilter({ payload }, { put }) {
      yield put({
        type: 'statePreFilters',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryPreFilters(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addPreFilter(state, { payload }) {
      return {
        ...state,
        newPreFilter: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewPreFilter(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editPreFilter(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    savePreFilter(state, { payload }) {
      return {
        ...state,
        savePreFilter: payload,
        newPreFilter: false,
        selectedItem: false,
      };
    },

    showEditItemPreFilter(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));

      return {
        ...state,
        list,
      };
    },
    statePreFilters(state, { payload }) {
      return {
        ...state,
        isActive: payload,
      };
    },

    searchPreFilters(state, { payload }) {
      return {
        ...state,
        searchCriteria: payload,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newPreFilter: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
        isActive: '',
      };
    },
  },
};

export default Model;
